export enum ErrorMessage {
    NonUnique = 'NON_UNIQUE_PROPERTIES',
    ContactIsAssignedToBonusCondition = 'CONTACT_IS_ASSIGNED_TO_BONUS_CONDITION',
    ContactIsAssignedAsMainContact = 'CONTACT_IS_ASSIGNED_AS_MAIN_CONTACT',
}
